import React from 'react';
import { LinearProgress } from '@mui/material';
import '../healthoverview.css';
import { Typography } from '@mui/material';
const DailyProgressBar = ({ progress, max, color }) => {
  const percentage = (progress / max) * 100;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <LinearProgress
        variant="determinate"
        value={percentage}
        sx={{
          backgroundColor: `${color}40`,
          '& .MuiLinearProgress-bar': {
            backgroundColor: color,
          },
          display: 'flex',
          width: '150px',
          height: '10px',
          alignItems: 'center',
          borderRadius: '20px',
        }}
      />
      <span style={{ typography: 'body2' }}>
        <Typography variant="body2" color="text.secondary">
          {progress} / {max}
        </Typography>
      </span>
    </div>
  );
};

export default DailyProgressBar;
